import React from 'react';
import { COUNTRIES } from './CountrySelect';

const Coverage = () => {
  return (
    <section id="coverage" className="py-16 bg-gray-50"> {/* Or use bg-white if preferred */}
      <div className="container mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center animate-on-scroll">
          Couverture <span className="text-primary-custom">Géographique</span>
        </h2>
        <p className="section-description2 animate-on-scroll">
        OuiGoo est actuellement présent dans des zones clés d’Afrique de l’Ouest, avec une expansion en cours pour desservir davantage de régions.
        </p>
        <p className="text-xl text-gray-500 mb-6 animate-on-scroll">
          Nous opérons actuellement dans les pays suivants
        </p>
        <div className="flex justify-center space-x-12 animate-on-scroll">
          {COUNTRIES.map(({ code, label, Flag }) => (
            <div key={code} className="text-center">
              <Flag className="w-20 h-14 mx-auto mb-3 rounded-lg shadow ring-1 ring-black/5" />
              <h3 className="text-xl font-semibold text-gray-800">{label}</h3>
            </div>
          ))}
        </div>
        <p className="text-md text-gray-500 mt-8 animate-on-scroll">
          Votre pays n'est pas listé ? <a href="/contact" className="text-primary-custom hover:underline">Contactez-nous</a> pour discuter de vos besoins et de nos plans d'expansion.
        </p>
      </div>
    </section>
  );
};

export default Coverage;
